import { Link } from 'react-router';
import { Button } from '@/components/ui/Button';
import { NotFound404 } from '@/illustrations/NotFound404';
import { popularDestinations } from '@/data/studio';
import { useSeo } from '@/lib/seo';

export default function NotFound() {
  useSeo({
    title: 'Not found',
    description: 'The page you asked for does not exist. Use the navigation to find your way back.',
  });

  return (
    <section className="min-h-[70dvh] flex items-center justify-center px-6 py-24 md:py-32">
      <div className="mx-auto max-w-2xl flex flex-col items-center text-center gap-10">
        <div className="w-full max-w-md text-ink-primary">
          <NotFound404 className="w-full h-auto" />
        </div>
        <div className="flex flex-col gap-4">
          <h1 className="display-md">The page you looked for is not here.</h1>
          <p className="text-ink-secondary max-w-md mx-auto">
            Maybe a typo in the URL, maybe a link we retired. Either way - you are not lost for long.
          </p>
        </div>
        <div className="flex flex-wrap gap-4 justify-center">
          <Button to="/" variant="primary">Back home</Button>
          <Button to="/contact" variant="secondary">Tell us what you needed</Button>
        </div>
        <div className="flex flex-col items-center gap-3 mt-4">
          <span className="mono-meta text-ink-muted">Or try</span>
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            {popularDestinations.map((d) => (
              <Link
                key={d.href}
                to={d.href}
                className="text-sm font-sans text-ink-primary hover:text-accent underline underline-offset-4"
              >
                {d.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </section>
  );
}
